module.exports = __webpack_public_path__ + "static/media/squiggles-blue.c56914f5.png";